import { format } from "date-fns";
import { Option } from "../../../common/types/Types";
import { EmployeeScheduledQualificationInterface } from "../../../common/interfaces/ScheduledQualificationInterface";
import { getUserFullName } from "../../../common/utils/getUserFullName";
import { UpsertScheduleQualificationModalInterface } from "../UpsertScheduleQualificationModalSlice";

interface Args {
    employeeScheduledQualification?: EmployeeScheduledQualificationInterface;
    isEstablishmentManager: boolean;
    employeeId?: string | number;
    current?: UpsertScheduleQualificationModalInterface["formValues"];
}

export const buildPrefillFormValues = (
    args: Args,
): UpsertScheduleQualificationModalInterface["formValues"] | undefined => {
    const {
        employeeScheduledQualification,
        isEstablishmentManager,
        employeeId,
        current,
    } = args;

    if (employeeScheduledQualification) {
        const scheduledQualification =
            employeeScheduledQualification.scheduled_qualification;

        return {
            employeeScheduledQualificationId:
                scheduledQualification.id.toString(),
            employee: {
                value: employeeScheduledQualification.employee.id.toString(),
                label:
                    getUserFullName(
                        employeeScheduledQualification.employee.user,
                    ) ?? "",
            } as Option,
            educator: {
                value: scheduledQualification.educator.id.toString(),
                label: scheduledQualification.educator.name,
            } as Option,
            qualification: {
                value: scheduledQualification.qualification.id.toString(),
                label: scheduledQualification.qualification.name,
            } as Option,
            startDate: format(scheduledQualification.starts_at, "yyyy-MM-dd"),
            endDate: format(scheduledQualification.ends_at, "yyyy-MM-dd"),
        };
    }

    // Create-mode default: prefill employee for non-managers
    if (!isEstablishmentManager && employeeId != null) {
        return {
            ...(current ?? {}),
            employee: { value: employeeId.toString(), label: "" },
        } as UpsertScheduleQualificationModalInterface["formValues"];
    }

    return current;
};
